/** Label shown in the lyrics inspector for the legacy `foreign` bucket (Latin vs non-Latin heuristic). */
export const LYRICS_LANGUAGE_NON_ENGLISH_DISPLAY = 'Non-English';

/**
 * Maps stored API values (e.g. `en`, `foreign`, ISO639-1 codes) to a readable language name for the inspector.
 */
export function lyricsLanguageToDisplay(stored: string | null | undefined): string {
  if (stored == null || stored === '') {
    return '';
  }
  const trimmed = stored.trim();
  const lower = trimmed.toLowerCase();
  if (lower === 'en') {
    return 'English';
  }
  if (lower === 'foreign') {
    return LYRICS_LANGUAGE_NON_ENGLISH_DISPLAY;
  }
  if (/^[a-z]{2}(-[a-z]{2})?$/i.test(trimmed)) {
    const code = trimmed.split('-')[0].toLowerCase();
    try {
      const displayNames = new Intl.DisplayNames(['en'], { type: 'language' });
      const name = displayNames.of(code);
      if (name) {
        return name;
      }
    } catch {
      // fall through
    }
  }
  return trimmed;
}

/**
 * Converts inspector text back to values the API and fetch job expect (`en`, `foreign`), or passes through custom labels.
 */
export function lyricsLanguageForApi(display: string): string | null {
  const trimmed = display.trim();
  if (trimmed === '') {
    return null;
  }
  const lower = trimmed.toLowerCase();
  if (lower === 'english') {
    return 'en';
  }
  if (lower === LYRICS_LANGUAGE_NON_ENGLISH_DISPLAY.toLowerCase() || lower === 'foreign') {
    return 'foreign';
  }
  return trimmed;
}
